import { Component } from '@angular/core';

@Component({
  selector: 'client-form-instruction',
  templateUrl: './client-form-instruction.component.html',
  standalone: false
})
export class ClientFormInstructionComponent {
}
